<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Employee Offboarding</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> Off Boarding Type </label>
                        <v-select
                            placeholder="Select Off Boarding Type"
                            v-model="offBoardingType"
                            :options="offBoardingTypes"
                            label="name"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> Last Working Date </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="date"
                            placeholder=""
                            v-model="formData.last_working_date"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"><span class="required">*</span> Details Reason </label>
                        <textarea
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="text"
                            placeholder=""
                            v-model="formData.details_reason"
                        ></textarea>
                      </div>
                    </div>

                    <div class="col-12">
                      <label class="form-label">Attachment</label>
                      <BlobFileViewer :attachments="formData.attachments" />
                      <FileUpload
                          :is-drag-active="true"
                          button-text="Upload Documents"
                          v-model="formData.attachments"
                      >
                      </FileUpload>
                    </div>

                    <div class="col-6 text-center mb-2 mt-2">
                      <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleContact from "@/services/modules/contact";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import handleHospital from '@/services/modules/hospital'
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import { handleAttachments } from '@/services/utils/global';

const props = defineProps({
    formData:{
      type:Object,
      default:{}
    },
    contactInfo: {
      type: Object,
    },
});

const emit = defineEmits(['getOffBoardingList']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const offBoardingType = ref([]);
const offBoardingTypes = ref([]);
const isEdit = ref(false);
const contactProfile = ref('');
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const {
  fetchTypes,
  createEmployeeOffBoarding,
  updateEmployeeOffBoarding
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact();
const { fetchNoteMasterList } = handleHospital()

const submit = async() => {
    const query = getQuery();
    loading.value = true;
    if (isEdit.value){
      await updateData(query)
      return
    }
    await storeData(query)
}

const storeData = async (query) => {
  let offBoardingData = {};
  offBoardingData.contact_profile_id = props.formData.contact_profile_id;
  offBoardingData.off_boarding_type_id = offBoardingType.value ? offBoardingType.value.id : null;
  offBoardingData.last_working_date = props.formData.last_working_date;
  offBoardingData.details_reason = props.formData.details_reason;

  const form = new FormData();
  Object.entries(offBoardingData).forEach(([key, value]) => {
    Array.isArray(value)
        ? value.forEach((item, i) => form.append(`${key}[${i}]`, item))
        : form.append(key, value !== null ? value : '');
  });

  const attachments = props.formData.attachments;
  if (attachments && attachments.length) {
    handleAttachments(form, attachments);
  }

  await createEmployeeOffBoarding(form, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getOffBoardingList");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const updateData = async (query) => {
  let offBoardingData = {};
  offBoardingData.contact_profile_id = props.formData.contact_profile_id;
  offBoardingData.off_boarding_type_id = offBoardingType.value ? offBoardingType.value.id : null;
  offBoardingData.last_working_date = props.formData.last_working_date;
  offBoardingData.details_reason = props.formData.details_reason;
  offBoardingData.id = props.formData.id;
  console.log(offBoardingData)
  const form = new FormData();
  Object.entries(offBoardingData).forEach(([key, value]) => {
    Array.isArray(value)
        ? value.forEach((item, i) => form.append(`${key}[${i}]`, item))
        : form.append(key, value !== null ? value : '');
  });

  const attachments = props.formData.attachments;
  if (attachments && attachments.length) {
    handleAttachments(form, attachments);
  }

  await updateEmployeeOffBoarding(form, offBoardingData.id, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getOffBoardingList");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getOffBoardingTypeList = async () => {
  let query = getQuery();
  query += '&is_all=true&status=active&note_type=off_boarding_type'

  offBoardingTypes.value = []

  await fetchNoteMasterList(query).then(res => {
    if (!res.status){
      offBoardingTypes.value = []
      return
    }
    offBoardingTypes.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

watch(() => props.formData, (newVal) => {
  if (newVal.off_boarding_type_id) {
    offBoardingType.value = {
      id: newVal.off_boarding_type_id,
      name: newVal.off_boarding_type
    }
  }
  if (newVal.is_edit){
    isEdit.value = true;
  }
}, { immediate: true, deep: true })

onMounted(() => {
  getOffBoardingTypeList();
})

</script>
